import React from 'react';
import { Toaster } from 'react-hot-toast';
import ClientRoutes from './routes';
import './App.scss';

function App() {
  return (
    <div className="App">
      <ClientRoutes />
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
